// utils/applyTheme.js
export function applyTheme(theme, customColor = null) {
  const themes = ['theme-light', 'theme-dark', 'theme-sepia', 'theme-blueprint', 'theme-custom'];
  themes.forEach(t => document.body.classList.remove(t));
  document.body.classList.add(`theme-${theme}`);

  if (theme === 'custom') {
    const bg = customColor || localStorage.getItem('customBgColor') || '#ffffff';
    const yiq = (parseInt(bg.slice(1, 3), 16) * 299 +
                 parseInt(bg.slice(3, 5), 16) * 587 +
                 parseInt(bg.slice(5, 7), 16) * 114) / 1000;
    const textColor = yiq >= 128 ? '#000000' : '#ffffff';

    document.documentElement.style.setProperty('--custom-bg', bg);
    document.documentElement.style.setProperty('--custom-text', textColor);
    document.documentElement.style.setProperty('--custom-button-bg', bg);
    document.documentElement.style.setProperty('--custom-button-text', textColor);
  }
}
